export default __webpack_public_path__ + "static/Quickinstallation_Tile_9008_Step_09-a7d2703f6f1526827d8f6911dfaf2194.webp";